"use strict";
/**
 * @module Services.Metrics
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A snapshot of all metrics for a measured entity class.
 */
var MeasuredEntityClassMetrics = /** @class */ (function () {
    function MeasuredEntityClassMetrics(metricNames, values) {
        this.metricNames = metricNames;
        this.values = values;
    }
    return MeasuredEntityClassMetrics;
}());
exports.MeasuredEntityClassMetrics = MeasuredEntityClassMetrics;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metrics/measured-entity-class-metrics.js
// module id = 1330
// module chunks = 1